import type { IconType } from "../icons/icon";

export type FieldType = "text" | "email" | "phone" | "link";

export const FIELD_CONFIG: Record<FieldType, { icon: IconType; getHref?: (v: string) => string; target?: string }> = {
  text: { icon: "text" },
  email: { icon: "email", getHref: (v) => `mailto:${v}` },
  phone: { icon: "phone", getHref: (v) => `tel:${v}` },
  link: { icon: "external-link", getHref: (v) => v, target: "_blank" },
};
